import { combineReducers } from 'redux'
import {
	AgreementsSlice,
	LandingsSlice,
	merchantStatusSlice,
	fakeResponsesSlice,
	templateSlice,
	productOrderStatusesSlice,
	serviceNotificationsSlice,
	tagSlice,
} from 'Pages/admin'

export const adminSlice = combineReducers({
	[AgreementsSlice.name]: AgreementsSlice.reducer,
	[LandingsSlice.name]: LandingsSlice.reducer,
	[merchantStatusSlice.name]: merchantStatusSlice.reducer,
	fakeResponsesSlice,
	[templateSlice.name]: templateSlice.reducer,
	[productOrderStatusesSlice.name]: productOrderStatusesSlice.reducer,
	[serviceNotificationsSlice.name]: serviceNotificationsSlice.reducer,
	[tagSlice.name]: tagSlice.reducer,
})
